import React, { useContext, useEffect, useState } from 'react';

import { Box, makeStyles } from '@material-ui/core';
import {AppContext} from '../../../contexts/AppContext';
import Colors from '../../../helpers/Colors';
import Text from '../Text';
import Steps from './Steps';
import WarningMessage from "./WarningMessage";
import {DASH, DELIVERY_IN_HOUSE} from "../../../helpers/Constants";

function CompletedRow({ order }) {
    const classes = useStyles();

    const [orderTime, setOrderTime] = useState(0);
    const [cubbyName, setCubbyName] = useState(null);

    const { isAssignerMode } = useContext(AppContext);

    /**
     * show DASH as a delivery mode when delivery mode is null or
     * delivery mode type is in_house with no delivery partner selections
     * @param selectedOrder
     * @returns {string|*}
     */
    const getDeliveryMode = (selectedOrder) => {
        if (!selectedOrder.deliveryMode ||
            (selectedOrder.deliveryMode?.deliveryModeType === DELIVERY_IN_HOUSE
                && order.deliveryPartnerSelection === null)) {
            return DASH;
        }
        return order.deliveryMode.deliveryModeDisplayName;
    }

    useEffect(() => {
        const acceptedStatus = order.statusHistory.find(item => item.status === 'ACCEPTED');
        let acceptedTime = Date.now();
        if (acceptedStatus) {
            acceptedTime = Number(acceptedStatus.eventCompletedTime);
        }
        if(isAssignerMode){
            const readyToDispatchStatus = order.statusHistory.reverse().find(item => item.status === 'READY_TO_DISPATCH');
            const period = Number(readyToDispatchStatus?.eventCompletedTime) - acceptedTime;
            setOrderTime(Math.round(period / 60000));
            setCubbyName(readyToDispatchStatus?.metadata?.ASSIGNED_TO);
        }

        let endStatus = order.statusHistory.find(item => item.status === 'COMPLETED')
            || order.statusHistory.find(item => item.status === 'DISPATCHED');
        if (!endStatus) {
            return;
        }
        const dispatchedTime = Number(endStatus.eventCompletedTime);

        const diff = dispatchedTime - acceptedTime;
        setOrderTime(Math.round(diff / 60000));

    }, [order.statusHistory]);

    return (
        <Box className={classes.contentItemContainer}>
            <Box style={{display: 'flex', flex: 1}}>
                <Box className={classes.contentIdRowContainer}>
                    <Text className={classes.contentOrderIdLabel}>{order.externalId}</Text>
                </Box>
                <Box className={classes.contentRowContainer}>
                    <Text className={classes.contentLabel}>{order.brandInfo ? order.brandInfo.name : ""}</Text>
                </Box>
                <Box className={classes.contentRowContainer}>
                    <Text className={classes.contentLabel}>{order.sourceInfo ? order.sourceInfo.name : ""}</Text>
                </Box>
                <Box className={classes.contentRowContainer}>
                    <Text className={classes.contentLabel}>{getDeliveryMode(
                        order)}</Text>
                </Box>
                <Box className={classes.contentRowContainer}>
                    <Box className={classes.timerContainer}>
                        <Text className={classes.contentLabel}>
                            {orderTime} MIN
                        </Text>
                    </Box>
                </Box>
                {isAssignerMode ? (
                    <Box className={classes.contentRowContainer}>
                    <Text className={classes.contentLabel}>{cubbyName}</Text>
                    </Box>) : null}
                <Box className={classes.contentRowStatusView}>
                    <Steps
                        type={'completed'}
                        statusHistory={order.statusHistory}
                        order={order}
                    />
                </Box>
            </Box>
            <Box style={{paddingLeft: 20}}>
                <WarningMessage order={order} type={'completed'}/>
            </Box>
        </Box>
    );
}

export default CompletedRow;


const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        width: '100%',
        flex: 1,
        height: '100%',
    },
    contentOrderIdLabel: {
        color: Colors.textColor,
        opacity: 0.6,
        fontSize: 16,
        fontWeight: '600',
        paddingLeft: 20,
        fontFamily: 'DINNextLTPro-Regular',
    },
    contentLabel: {
        color: Colors.textColor,
        opacity: 0.6,
        fontSize: 16,
        fontWeight: '600',
        fontFamily: 'DINNextLTPro-Regular',
    },
    contentLatedLabel: {
        color: Colors.red,
        opacity: 0.6,
        fontSize: 16,
        fontWeight: '600',
        fontFamily: 'DINNextLTPro-Regular',
    },
    contentItemContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        height: '100%',
        borderRadius: 4,
        border: '1px solid #EDEDED',
        marginBottom: 8,
    },
    contentLatedItemContainer: {
        display: 'flex',
        flex: 1,
        direction: 'row',
        height: 60,
        border: '1px solid #EDEDED',
        marginBottom: 8,
        borderRadius: 4,
        backgroundColor: Colors.fadedRed,
    },
    contentIdRowContainer: {
        display: 'flex',
        flex: 1.8,
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    contentRowContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    contentButtonRowContainer: {
        display: 'flex',
        flex: 1.5,
        height: '100%',
        justifyContent: 'flex-end',
        paddingRight: 15,
        alignItems: 'center',
    },
    contentRowStatusView: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: 9.6,
    },
    warningIcon: {
        height: 10,
        width: 10,
        objectFit: 'contain',
    },
    timerContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    timerWarningIconContainer: {
        height: 18,
        width: 18,
        borderRadius: 20,
        marginLeft: 6,
        backgroundColor: Colors.red,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));
